import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import type { ModalProps } from "@/shared/models/legacy-types";
import { Button, Dialog, ShieldWarningIcon } from "@/shared/ui";

export const ScheduleErrorModal = ({ show, onClose }: ModalProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={ShieldWarningIcon}>
          <Dialog.Title>{t`Unable to create consultation`}</Dialog.Title>

          <Dialog.Description>
            {t`We couldn't complete your consultation due to a system error. Please try again shortly.`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" variant="secondary" onClick={handleBack}>
            {t`Back`}
          </Button>

          <Button size="lg" onClick={onClose}>
            {t`Try again`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
